import { Link, useLocation} from "react-router-dom";
import { ArrowBackIcon } from "./Icons";
import React, { useState, useEffect, useRef } from 'react';
import Typed from 'typed.js';
import "./../App.css";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TalksTable from './talksTable';
import {getAttendance} from './updatables';
import { useMediaQuery } from 'react-responsive';

const Conferences = ({page}) => {
  const isSmallScreen = useMediaQuery({ maxWidth: 670 });

  const [attendance, setAttendance] = React.useState([]);
  
  React.useEffect(() => {
      async function loadAttendance() {
          const data = await getAttendance();
          setAttendance(data);
      }

      loadAttendance();
  }, []);

    return <div style={{height: "auto", width: "100%", position: "relative", backgroundSize: "cover", backgroundPosition: "center", zIndex: 0, display: "inline-block", justifyContent: "space-between"}}>
      <div id="page" style={{marginLeft: isSmallScreen ? "-8%" : "0px", fontSize: isSmallScreen ? "30px" : "40px"}}>
        <Link to="/">
        </Link>
        {page}
      </div>
      <div className="tree" style={{marginLeft: isSmallScreen ? "4%" : "24px"}}>
        <ul>
          <li>
            <a style={{cursor: "default"}}>
                <h1 style={{fontSize: isSmallScreen ? "14px" : "28px"}}>\talks + posters</h1>
                {/* <p style={{fontSize: isSmallScreen ? "12px" : "16px"}}>I regularly present my research at conferences and seminars. Below you can find a list of these talks along with linked materials.</p> */}
                <TalksTable/>
            </a>
          </li>
          <li>
            <a style={{cursor: "default"}}>
                <h1 style={{fontSize: isSmallScreen ? "14px" : "28px"}}>\attendance</h1>
                {/* <p style={{fontSize: isSmallScreen ? "12px" : "16px"}}>Think you remember seeing me at a conference? Take a look at the list below to see if we've crossed paths at one of these events!</p> */}
                <TableContainer style={{marginLeft: isSmallScreen ? "0%" : "32px"}}>
                  <Table sx={{ width: isSmallScreen ? "200%" : "90%", tableLayout: "fixed",
                  "& .MuiTableCell-head": {
                      fontFamily: "mainFont",
                      fontWeight: 700,
                      color: "#7c7788",
                      fontSize: isSmallScreen ? "8px" : "14px"
                      },
                      "& .MuiTableCell-body": {
                      fontFamily: "mainFont",
                      color: "#7c7788",
                      fontSize: isSmallScreen ? "8px" : "14px"
                      },
                  }} size="small">
                      <TableHead>
                      <TableRow>
                          <TableCell sx={{width: "35%"}}>Date</TableCell>
                          <TableCell sx={{width: "45%"}}>Conference</TableCell>
                          <TableCell sx={{width: "20%"}}>Location</TableCell>
                      </TableRow>
                      </TableHead>
                      <TableBody>
                      {attendance.map((row) => (
                          <TableRow
                          key={row.role}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 },
                          transition: "background-color 0.2s ease",
                          "&:hover": {
                          backgroundColor: "#F0B6D520",
                          }, }}
                          >
                          <TableCell align="left" style={{fontFamily: "mainFontPar"}}>{row.date}</TableCell>
                          <TableCell component="th" scope="row" style={{fontFamily: "mainFontItalic"}}>
                              {row.conference}
                          </TableCell>
                          <TableCell align="left" style={{fontFamily: "mainFontPar"}}>{row.location}</TableCell>
                          </TableRow>
                      ))}
                      </TableBody>
                  </Table>
              </TableContainer>
            </a>
          </li>
        </ul>
      </div>
    </div>;
};

export default Conferences;